import { Module } from "@nestjs/common";
import { ScheduleModule } from "@nestjs/schedule";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { SamplePoController } from "./sample-po.controller";
import { SamplePoService } from "./sample-po.service";
// import { SamplePoOrdersEntity } from "./entities/buyer-master.entity";
// import { SamplePoOrdersRepo } from "./repositories/buyer-master.repo";
// import { ExcelEntity } from "./entities/sample-po-order.entity";
// import { ExcelRepository } from "./repositories/sample-po-order.repo";
import { SamplecoLineEntity } from "./entities/sample-coLine.entity";
import { SampleCoLineRepo } from "./repositories/sample-co-line-repo";
import { SamplePoOrderEntity } from "./entities/sample-po-order.entity";
import { samplePoOrderRepository } from "./repositories/sample-po-order.repo";
import { buyerEntity } from "./entities/buyer-master.entity";
import { BuyerMasterRepo } from "./repositories/buyer-master.repo";



@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forFeature([buyerEntity,SamplePoOrderEntity,SamplecoLineEntity])],
  controllers: [SamplePoController],
  providers: [ApplicationExceptionHandler,SamplePoService,BuyerMasterRepo,samplePoOrderRepository,SampleCoLineRepo,]
})
export class SamplePoModule { }